import { withViewModel } from '../../../infrastructure/components/with-view-model';
import URLParameterRegistrationFormPresentation from './url-parameter-registration-form.presentation';
import URLParameterRegistrationFormVM from './url-parameter-registration-form.viewmodel';

interface IProps {
    vm: URLParameterRegistrationFormVM;
}

const URLParameterRegistrationFormContainer = withViewModel(
    URLParameterRegistrationFormPresentation,
    (props: IProps) => {
        return props.vm;
    }
);

export { URLParameterRegistrationFormContainer as URLParameterRegistrationForm };
